import React from 'react'

function AlertPage() {
    return (
        <section class="alerts">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="alert__title">
              <h2>
                Оповещение о новых объявлениях
              </h2>
            </div>
            <div class="alert__subtitle">
              <p>
                Если вы не нашли в продаже группу с подходящими параметрами, вы
                всегда можете оформить подписку на новые объявления, настроив
                свой фильтр с подходящими параметрами.
              </p>
              <p>
                Как только объявление с нужными характеристиками будет
                опубликовано на сайте, вам на почту redslon@mail.ru придет
                уведомление со ссылкой на объявление.
              </p>
            </div>
          </div>
          <div class="col-lg-9 offset-lg-1 col-10 m-auto">
            <div class="price__items d-flex">
              <div class="price-item__count item-count">
                <div class="item-count__box">
                  <div class="item-count__subs">
                    Подписчики
                  </div>
                  <div class="item-count__hw d-flex">
                    <div id="id66" class="range">
                      <button id="id661" class="range__button_1">
                        <div class="range__dot"></div>
                      </button>
                      <button id="id662" class="range__button_2">
                        <div class="range__dot"></div>
                      </button>
                      <div id="id66b" class="range__between"></div>
                    </div>

                    <div class="box d-flex">
                      <input
                        id="id66i1"
                        class="range_inpt1"
                        type="number"
                        min="1"
                        max="1500"
                      />
                      <input
                        id="id66i2"
                        class="range_inpt2"
                        type="number"
                        min="10"
                        max="1500"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="price-item__count item-count">
                <div class="item-count__box">
                  <div class="item-count__subs">
                    Доход
                  </div>
                  <div class="item-count__hw d-flex">
                    <div id="id666" class="range r2">
                      <button id="id6611" class="range__button_1">
                        <div class="range__dot"></div>
                      </button>
                      <button id="id6622" class="range__button_2">
                        <div class="range__dot"></div>
                      </button>
                      <div id="id66bb" class="range__between"></div>
                    </div>
                    <div class="box d-flex">
                      <input
                        id="id66i11"
                        class="range_inpt1"
                        type="number"
                        min="5000"
                        max="0"
                      />
                      <input
                        id="id66i22"
                        class="range_inpt2 pt2"
                        type="number"
                        min="0"
                        max="0"
                      />
                      <div class="item-count__after">
                        До
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="price-item__count item-count">
                <div class="item-count__box">
                  <div class="item-count__subs">
                    Цена
                  </div>
                  <div class="item-count__hw d-flex">
                    <div id="id6666" class="range r22">
                      <button id="id66111" class="range__button_1">
                        <div class="range__dot"></div>
                      </button>
                      <button id="id66222" class="range__button_2">
                        <div class="range__dot"></div>
                      </button>
                      <div id="id66bbb" class="range__between"></div>
                    </div>
                    <div class="box d-flex">
                      <input
                        id="id66i111"
                        class="range_inpt1"
                        type="number"
                        min="10"
                        max="0"
                      />
                      <input
                        id="id66i222"
                        class="range_inpt2 pt2"
                        type="number"
                        min="0"
                        max="0"
                      />
                      <div class="item-count__after">
                        До
                      </div>
                    </div>
                  </div>
                  <div class="item-count__polz"></div>
                </div>
              </div>
            </div>
            <div class="price__search d-flex">
              <div class="price-search__item search-item">
                <div class="search-item__title">
                  Тематика
                </div>

                <div class="dropdown">
                  <button class="search-item__vp1 text-align">
                    Бизнес
                    <div class="dropdown-child stylesdc">
                      <a href="#">Подраздел 1</a>
                      <a href="#">Подраздел 2</a>
                      <a href="#">Подраздел 3</a>
                      <a href="#">Подраздел 4</a>
                      <a href="#">Подраздел 5</a>
                    </div>
                  </button>
                </div>
              </div>
              <div class="price-search__item search-item">
                <div class="search-item__title">
                  Способ передачи
                </div>
                <div class="dropdown vp1">
                  <button class="search-item__vp2 vp1 text-align">
                    Права владельца
                    <div class="dropdown-child vpchild stylesdc">
                      <a href="#">Подраздел 1</a>
                      <a href="#">Подраздел 2</a>
                      <a href="#">Подраздел 3</a>
                      <a href="#">Подраздел 4</a>
                      <a href="#">Подраздел 5</a>
                    </div>
                  </button>
                </div>
              </div>
              <div class="price-search__item search-item">
                <form action="#" class="price__form">
                  <input class="search-item3__search" placeholder="Поиск" />
                </form>
                <div class="search-item3__subf">
                  <a href="#" class="search-item3__subf_item"
                    >Сбросить фильтр</a
                  >
                </div>
              </div>
            </div>
            <div class="price-search__item search-item price-sort d-flex">
              <div class="price-sort__title">
                Сортировать
              </div>
              <div class="price-sort__items d-flex">
                <div class="price-sort__item">
                  По Актуальности
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
                <div class="price-sort__item">
                  По цене
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
                <div class="price-sort__item">
                  По Подписчикам
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
                <div class="price-sort__item">
                  По Доходу
                  <div class="price-sort-item__up"></div>
                  <div class="price-sort-item__down"></div>
                </div>
              </div>
            </div>
            <div class="price-search__item search-item sm d-flex ml-auto">
              <div class="sm__item psi1">
                <a href="#"><i class="fas fa-globe"></i></a>
              </div>
              <div class="sm__item psi2">
                <a href="#"><i class="fab fa-tiktok"></i></a>
              </div>
              <div class="sm__item psi3">
                <a href="#"><i class="fab fa-youtube"></i></a>
              </div>
              <div class="sm__item psi4">
                <a href="#"><i class="fab fa-vk"></i></a>
              </div>
              <div class="sm__item psi5">
                <a href="#"><i class="fab fa-instagram"></i></a>
              </div>
              <div class="sm__item psi6">
                <a href="#"><i class="fab fa-facebook-f"></i> </a>
              </div>
              <div class="sm__item psi7">
                <a href="#"><i class="fab fa-odnoklassniki"></i></a>
              </div>
              <div class="sm__item psi8">
                <a href="#"><i class="fab fa-telegram-plane"></i></a>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="alerts__btns d-flex">
              <div class="alerts__btn">
                <a href="#" class="green"> ПОДПИСАТЬСЯ</a>
              </div>
              <div class="alerts__btn">
                <a href="#" class="berez">ПОСМОТРЕТЬ ВЫБОРКУ</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    )
}

export default AlertPage
